import React, { useState, useRef, useEffect, useContext } from "react";
import Lottie from "lottie-web";
import MyContext from "../../context/MyContext";
import AuthContext from "../../context/userAuth.context";
import TickerContext from "../../context/ticker";
import axios from "axios";
import { loadLottieJson } from "../../Utils/lottieCache";

const CharacterLoader = ({ value, ticker, width, player, isAnimatedText }) => {
  const {
    CanvasDisplay,
    onePxEquivalent,
    EditorZoom,
    LayersData,
    isPlayClicked,
    CharacterRef,
    setCharacterRef,
  } = useContext(MyContext);

  const [CanvChar, setCanvChar] = useState(null);

  const refnew = useRef();

  const [chechState, setchechState] = useState(true);

  const [LoopComplete, setLoopComplete] = useState(false);

  const { authenticationData } = useContext(AuthContext);

  const { TickerStart } = useContext(TickerContext);

  const [CurrentFrame, setCurrentFrame] = useState(0);

  useEffect(async () => {
    // debugger
    if (value.character_FilePath !== undefined) {
      if (value.Added) {
        if (!value.JSONValue) {
          // Downloaded once per page and shared by every layer that uses the same file.
          value.JSONValue = await loadLottieJson(
            authenticationData.ApiBaseURL,
            value.character_FilePath
          );
        }

        // console.log("Coming in Character Loader");
        const data = Lottie.getRegisteredAnimations();
        for (let i = 0; i < data.length; i++) {
          if (data[i].name == value.AnimationId) {
            Lottie.destroy(value.AnimationId);
            setCanvChar(null);
          }
        }
        const get = Lottie.loadAnimation({
          container: refnew.current,
          name: value.AnimationId,
          renderer: "svg",
          loop: true,
          autoplay: chechState,
          animationData: value.JSONValue,
          rendererSettings: {
            preserveAspectRatio: "xMidYMin slice",
            viewBoxOnly: true,
            progressiveLoad: true,
          },
        });
        setCanvChar(get);
        setCharacterRef(refnew);
        // value.Added = false;
        if (isPlayClicked) {
          setchechState(true);
        } else {
          // setchechState(false);
          // get.stop(value.AnimationId);
        }
      }
    } else {
      setchechState(false);
      if (CanvChar) CanvChar.loop = true;
    }
  }, [LayersData]);

  

  useEffect(() => {
    if (player) {
      if (!chechState) {
        if (CanvChar)
          CanvChar.goToAndPlay(CurrentFrame, true, value.AnimationId);
        if (!LoopComplete) {
          setLoopComplete(true);
        }
      }
    } else if (!player) {
      if (!chechState) {
        if (CanvChar) CanvChar.stop(value.AnimationId);
      }
    }
  }, [player]);
  const generateTransformClass = () => {
    if (value.flip) {
      if (CanvasDisplay) {
        return value.flip;
      } else {
        return `rotate(${value.rotateAngle}deg) ` + value.flip;
      }
    } else {
      if (CanvasDisplay) {
        return value.flip;
      } else {
        return `rotate(${value.rotateAngle}deg)`;
      }
    }
  };
  // useEffect(() => {
  //   console.log("Ref value:", refnew.current);
  // });
  return (
    <div
      id={"OuterLoader-" + value.AnimationId}
      style={{
        display: value.InMultiDrag ? "none" : "block",
        transform: generateTransformClass(),
        width: "100%",
        height: "100%",
        position: "absolute",
        top: "0px",
        opacity: value.originalOpacity,
        zIndex: -1,
      }}
    >
      <div ref={refnew} id={"Loader" + value.AnimationId} />

    </div>
  );
};
export default CharacterLoader;
